import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VueSession from 'vue-session';
import VueCookie from 'vue-cookie';
import store from './store';
import router from './router';
import i18n from './i18n';
import VueBreadcrumbs from 'vue-breadcrumbs'

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(VueSession);
Vue.use(VueCookie);
Vue.use(VueBreadcrumbs);

var vm= new Vue({
  data: {
    isConnected: true,
    passwordTurnover: false,
    loadFinish: false,
  },
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

//regarde la derniere session pour y mettre le language
if (vm.$cookie.get('LANGUAGE')) {
  i18n.locale = vm.$cookie.get('LANGUAGE');
}
